import { useState } from 'react'
import { apiFetch } from '../lib/api'
import { inputCls } from '../lib/constants'

export default function Schedule({ currentUser, toggleAvailability, loadUsers }) {
  const [label, setLabel]   = useState(currentUser?.availability?.label || '')
  const [saving, setSaving] = useState(false)
  const [saved, setSaved]   = useState(false)

  async function saveLabel() {
    setSaving(true)
    await apiFetch(`/users/${currentUser.id}/availability`, {
      method: 'POST', body: JSON.stringify({ isAvailable: currentUser.availability.isAvailable, label })
    })
    setSaving(false); setSaved(true); loadUsers()
    setTimeout(() => setSaved(false), 2000)
  }

  if (!currentUser) return <p className="text-sm text-gray-600 mt-6">Please log in first.</p>
  return (
    <section>
      <div className="fade-up glass-card rounded-3xl border border-white/60 p-6 shadow-xl">
        <h2 className="title-font text-2xl font-bold text-gray-900 mb-6">My Schedule</h2>
        <div className="flex items-center gap-4 mb-6 flex-wrap">
          <span className={`rounded-full px-4 py-2 text-sm font-semibold ${currentUser.availability.isAvailable ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
            {currentUser.availability.isAvailable ? '🟢 Available' : '⭕ Unavailable'}
          </span>
          <button onClick={toggleAvailability} className="rounded-full border border-gray-800 px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100">Toggle Status</button>
        </div>
        {currentUser.availability.isAvailable && (
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Availability message</label>
            <input value={label} onChange={e => setLabel(e.target.value)} placeholder="e.g. Looking for lunch partner today" className={inputCls} />
            <button onClick={saveLabel} disabled={saving} className="mt-3 rounded-full bg-orange-500 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-600 disabled:opacity-50">
              {saving ? 'Saving…' : saved ? '✅ Saved!' : 'Save'}
            </button>
          </div>
        )}
        <div className="mt-8">
          <p className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3">Quick presets</p>
          <div className="flex flex-wrap gap-2">
            {['Free for breakfast 🌅', 'Looking for lunch 🥗', 'Dinner companion tonight 🌙', 'Brunch this weekend ☕'].map(p => (
              <button key={p} onClick={() => setLabel(p)} className="rounded-full border border-orange-200 bg-orange-50 px-4 py-2 text-xs font-semibold text-orange-700 hover:bg-orange-100">{p}</button>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
